import { Injectable } from '@angular/core';

import { Division, KeyValuePair } from '@reg/shared/model';

/**
 * Service used to get possible ways a division can be grouped.
 */
@Injectable()
export class DivisionGroupingService {
    // Consts are a copy of the DivisionGroupingType enum defined in the floarena-api
    public static BIRTHDATE: string = 'birthdate';
    public static GRADE: string = 'grade';

    private types: KeyValuePair[] = [];

    public static getNameFromDivisions(divisions: Division[]): string {
        if (!divisions || divisions.length === 0) {
            return 'Grade/Birthdate';
        } if (divisions.filter((x: Division) => x.divisionGroupingType === DivisionGroupingService.BIRTHDATE)
            .length === divisions.length) {
            return 'Birthdate';
        } if (divisions.filter((x: Division) => x.divisionGroupingType === DivisionGroupingService.GRADE)
            .length === divisions.length) {
            return 'Grade';
        } if (divisions.filter((x: Division) => !x.divisionGroupingType).length === divisions.length) {
            // Divions are not collecting grade or birthdate.
            return null;
        }
        return 'Grade/Birthdate';
    }

    /**
     * Constructor
     */
    constructor() {
        this.types.push(new KeyValuePair(DivisionGroupingService.BIRTHDATE, 'Birthdate'));
        this.types.push(new KeyValuePair(DivisionGroupingService.GRADE, 'Grade'));
    }

    /**
     * Get all division groupings
     */
    public getIndex(): KeyValuePair[] {
        return this.types;
    }

    /**
     * Get a single division grouping
     */
    public get(key: string): KeyValuePair {
        const foundTypes: KeyValuePair[] = this.types.filter((type: KeyValuePair) => type.key === key);

        if (foundTypes && foundTypes.length > 0) {
            // Found a match
            return foundTypes[0];
        }

        // No match found so construct a new one
        return new KeyValuePair(key, key);
    }
}
